<template>
    
       
    <div :class="classModal"  >
        
			<div class="modal-background"></div>
  			<div class="modal-card">
	    		<header class="modal-card-head" >
                      
                       
                   <table style="width:100%">
                       <tr>
                           <td colspan="3">
                                <div class="modal-card-title" style="width:100%" >
                                    <span v-show="createPossible || club.id=='demo'" > {{title[nav]}}</span>
                                    <span v-show="!createPossible && club.id!='demo'" ><s-l id="addtournoi_title2"> Crédit insuffisant</s-l></span>
                                    <div style="float:right" v-if="club.id!='demo'">
                                        <s-button theme="" label="" icon="times-circle" @onclick="close"/>
                                    </div>
                                </div>
                            </td>
                        </tr>
                       
                   </table>
				</header>
                 <div  class="fil" v-show="credit>0" >
                        <s-fil :options="tournoi.options"/>
                    </div>
				<section class="modal-card-body ssection"  >
                    
                    <div v-show="!createPossible && club.id!='demo'">
                        <div class="creditInsuffisant">
                            <s-l id="CreateTournoi_creditInsuffisant">Vous n'avez pas de crédits ou votre club ne possède pas d'abonnements.<br/>Vous devez avoir au moins 1 crédit pour créer un concours ou que votre club soit abonné</s-l>
                        </div>    
                        <div style="text-align:center;margin-top:30px">
                        <s-button theme="is-primary" label="Créditer votre compte" icon="coins" 
                        @onclick="payment"/>    
                        <div style="margin: 50px;">
                                 
                        </div>
                        <s-button theme="is-info" label="Abonner votre club" icon="credit-card" 
                        @onclick="openAbonnement=true"/> 
                        <div style="margin: 50px;">
                                 
                        </div>
                        <credits-by-video @sendCredit="sendCredit=true"  />
                        <s-info :open="sendCredit" @close="$emit('close')" :close="true">Petanque-app vous a offert des crédits : cliquez sur "Crédit" pour les récupérer !</s-info>
                        <s-modal
                            title="Choisir son abonnement"
                            :open="openAbonnement"
                            :close="true"
                            @close="openAbonnement=false"
                        >
                            <list-subscriptions :club="club"/>
                        </s-modal>  
                         
                         </div>

                    </div>
                    <div v-show="nav=='0' && createPossible ">
                        <div>
                            <div class="itemForm"> 
                            <div class="label"><s-l id="addtournoi_date"> Planifiez la date de votre concours  :</s-l> </div>
                            <div class="inputform"> 
                                    <input class="input is-danger is-rounded is-normal" type="date" width="200px" 
                                        v-model="dateValue" 
                                        :max="getDayMax"
                                        :min="getToday"
                                        :disabled="tournoi.state=='INPROGRESS'"
                                        /> 
                                    <div class="errorDate" v-if="errorDate">
                                        <s-l id="addTournoi_errorDate">Il y a déjà un tournoi planifié à cette date</s-l>
                                    </div>
                            </div>
                            
                        </div>
                        <div class="itemForm"> 
                            <div class="label"><s-l id="addtournoi_heure">Heure du concours :</s-l> </div>
                            <div class="inputform">  
                                    <input type="time" class="input is-danger is-rounded is-normal" 
                                    v-model="tournoi.heure"
                                    :disabled="tournoi.state=='INPROGRESS'"
                                     /> 
                                     
                                    </div>
                        </div>
                        <div class="itemForm" v-if="tournoi"> 
                            <div class="label">  <s-l id="addtournoi_nom">Description du concours : (falculatif)</s-l> </div>
                            <div class="inputform"> 
                                   <input class="input is-light is-rounded is-normal" 
                                    type="text" v-model="tournoi.description"
                                    placeholder="Description"/>
                            </div>
                            <div  style="float:left;margin-top: 20px" v-if="tournoi.id!='' && tournoi.options.emailAll">
                                <s-button  theme="is-small  is-warning" icon="envelope" label="Envoyer un rappel" @onclick="sendMailAll()" />
                            </div>
                            <div v-if="tournoi.id!='' && !disabledSave" style="float:right;margin-top: 20px">
                                <s-button afterIcon="fast-forward"  
                                theme="is-small is-primary" label="Passer au récapitularif" @onclick="nav=4" />
                            </div>
                              
                            
                        </div>
                        <div >
                            <s-modal
                                :open="openListSeason"
                                :close="true"
                                @close="openListSeason=false"
                                title="Liste des saisons"
                            >
                                <s-button icon="plus" label="Créer une nouvelle saison" theme="is-primary" 
                                    @onclick="$emit('createSeason')"/><br/><br/>
                                Sélectionner la saison :
                                <div v-for="saison in saisons" class="saisonSelect" v-on:click="inclureSaison(saison.id)">
                                    {{saison.nom}}
                                </div>
                            </s-modal> 
                           
                            <div v-if="saison==null" class="saison">
                            <s-button @onclick="openListSeason=true"
                                      icon="film"
                                      label="Affecter à une saison"
                                      theme="is-primary"
                                      v-show="tournoi.id==''"
                                      />
                            </div>
                            <div v-if="saison!=null" class="saison">
                                
                                Affecté à la saison : {{saisonLibelle}}
                            </div>
                             <div style="float:right;"  v-if="saison!=null && tournoi.id==''">
                                    <s-button icon="unlink" label="Enlever de la saison" theme="is-small is-danger" 
                                    @onclick="detacherSaison"/>
                                </div> 
                        </div>
                        </div>
                    </div>
					<div v-show="nav==1">
                         <list-select 
                            :nbs="[1,2,3]" 
                            :items="formations" 
                            :animation="nav==1" 
                            @select="setNbJoueursParEquipe"
                            mode=""
                             />
					</div>
                    <div v-show="nav==2">
                        <list-select 
                            :nb="tournoi.options.nbJoueursParEquipe" 
                            :items="compositions"  
                            :animation="nav==2"
                            @select="setMode"
                            mode="" />
                    </div>
                    <div v-show="nav==3">
                        
                       <list-select 
                            nb="1" 
                            :items="types"  
                            :animation="false"
                            @select="setCompetition"
                            :mode="tournoi.options.mode" />
                    
                    </div>
                    <div v-show="nav==5" v-if="tournoi.options.tabNbJoueursParEquipe">
                        Choisissez votre formation en fonction des parties :
                        <br/>
                        Nombre de parties : <input type="number"  v-model="tournoi.options.nbParties" class="is-primary"/>
                        <table width="100%" v-if="parseInt(tournoi.options.nbParties)>0 && parseInt(tournoi.options.nbParties)<10">
                            <tr >
                              <th style="text-align:center" v-for="partie in parseInt(tournoi.options.nbParties)">
                                  Partie {{partie}}
                              </th>
                            </tr>
                            <tr>
                                <td style="text-align:center" v-for="partie in parseInt(tournoi.options.nbParties)">
                                    <div style="margin: 10px">
                                       
                                    <s-button :theme="tournoi.options.tabNbJoueursParEquipe[parseInt(partie-1)]==1 ? 'is-success' : 'is-primary'" 
                                        label="Tête à tête" @onclick="setNbJoueursParEquipeByPartie(partie, 1)"/>
                                    </div>
                                     <div style="margin: 10px">
                                    <s-button :theme="tournoi.options.tabNbJoueursParEquipe[parseInt(partie-1)]==2 ? 'is-success' : 'is-primary'"
                                        label="Doublette" @onclick="setNbJoueursParEquipeByPartie(partie, 2)"/>
                                     </div><div style="margin: 10px">
                                    <s-button :theme="tournoi.options.tabNbJoueursParEquipe[parseInt(partie-1)]==3 ? 'is-success' : 'is-primary'"
                                        label="Triplette" @onclick="setNbJoueursParEquipeByPartie(partie, 3)"/>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div v-show="nav==4">
                        <table class="tableRecap">
                            <tr >
                            <td style="width:75%">Planifié le :</td><td>{{dateTournoi}} à  {{tournoi.heure}}</td>
                            </tr>
                            <tr v-show="tournoi.description!=''">
                            <td colspan="2">
                                    {{tournoi.description}}
                            </td>
                            </tr>
                            
                            <tr>
                                <td colspan="2">
                                <span v-show="tournoi.options.nbJoueursParEquipe==-1">Customisé</span>
                                <span v-show="tournoi.options.nbJoueursParEquipe==1">Individuel</span>
                                <span v-show="tournoi.options.nbJoueursParEquipe==2">Doublette</span>
                                <span v-show="tournoi.options.nbJoueursParEquipe==3">Triplette</span>
                                /
                                <span v-show="tournoi.options.competition==1">Tirage aléatoire</span>
                                <span v-show="tournoi.options.competition==2">Gagnant gagnant</span>
                                <span v-show="tournoi.options.competition==3">Tournoi par poules</span>
                                <span v-show="tournoi.options.nbJoueursParEquipe>1 || tournoi.options.nbJoueursParEquipe==-1">
                                    /
                                    <span v-show="tournoi.options.mode=='ALEA'">Mélée tournante</span>
                                    <span v-show="tournoi.options.mode=='FORME'
                                                    && tournoi.options.melee">Mélée</span>
                                    <span v-show="tournoi.options.mode=='FORME'
                                    && !tournoi.options.melee">Formée</span>
                                </span>
                                </td>
                            </tr>
                            
                            <tr v-show="(tournoi.options.competition==1 && !tournoi.options.GG) || tournoi.options.nbJoueursParEquipe==-1">
                            <td>Nombre de parties : </td>
                            <td>
                                <input type="number" class="input is-rounded is-normal is-primary" 
                                style="width:90px" 
                                v-model="tournoi.options.nbParties"
                                :disabled="tournoi.options.nbJoueursParEquipe==-1"
                                />
                            </td>
                            </tr>
                            <tr :class="(emailAll) ? 'notBottom' : ''">
                            <td><s-l id="sendAlertMailUser">Avertir vos membres du tournoi par mail :</s-l></td>
                            <td><s-button icon="" label="OUI" 
                                :theme="emailAll ? 'is-success is-small' : 'is-light is-small'" 
                                @onclick="setEmailALL()"
                                :disabled="club.demo"
                                />&nbsp;
                                <s-button icon="" label="NON" 
                                :theme="!emailAll ? 'is-danger is-small' : 'is-light is-small'"
                                 @onclick="setEmailALL()"
                                 :disabled="club.demo" />
                            </td>
                            </tr>
                            <tr v-show="subscribe && emailAll">
                                <td colspan="2">
                                    <s-l id="mailSendedWithLink">Un mail est envoyé dès la création du tournoi à vos membres et il contiendra un lien pour participer au tournoi</s-l>
                                </td>
                            </tr>
                            <tr v-show="!subscribe && emailAll">
                                <td colspan="2">
                                    <s-l id="mailSendedWithOutLink">Un mail est envoyé dès la création du tournoi à vos membres </s-l>
                                </td>
                            </tr>
                            <tr :class="subscribe ? 'notBottom' : ''">
                                <td>
                                    <s-l id="joueurPeutSInscrire">Vos membres peuvent s'inscrire eux même :</s-l>
                                </td>
                                <td>
                                    <s-button icon="" label="OUI" 
                                        :theme="subscribe ? 'is-success is-small' : 'is-light is-small'" 
                                        @onclick="setSubscribe()"
                                        :disabled="club.demo"
                                        />&nbsp;
                                    <s-button icon="" label="NON" 
                                        :theme="!subscribe ? 'is-danger is-small' : 'is-light is-small'"
                                        @onclick="setSubscribe()"
                                        :disabled="club.demo" />
                                </td>
                            </tr>
                            <tr v-if="subscribe" class="notBottom" >
                                <td>
                                   <s-l id="joueursInscrireEmail" :v="dateDelai.toLocaleString('fr-FR')">Vos membres doivent s'incrire avant le %v</s-l>
                                </td>
                                 <td rowspan="2" style="vertical-align:'middle'">
                                    <s-button @onclick="openDateConfiguration()" theme="is-warning is-small" mode="V" icon="edit" label="Modifier"/>
                                </td>
                            </tr>
                            <tr v-if="subscribe">
                                <td>
                                   <s-l v-if="!unsubscribe" id="joueursNotDesinscrireEmail" >Vos membres ne peuvent pas se désinscrire</s-l>
                                   <s-l v-if="unsubscribe" id="joueursCanDesInscrireEmail" :v="dateDelaiUnscribe.toLocaleString('fr-FR')">Vos membres doivent se désinscrire avant le %v</s-l>
                                </td>
                            </tr>
                            
                        <tr v-if="club.public &&  typeof(tournoi.saison)=='undefined'" class="notBottom">
                            <td>
                                <s-l id="tournoiIsPublic">Le tournoi est public :</s-l>
                            </td>
                            <td>
                             <s-button icon="" label="OUI" 
                                        :theme="public ? 'is-success is-small' : 'is-light is-small'" 
                                        @onclick="changePublicTournoi()"
                                        :disabled="club.demo"
                                        />&nbsp;
                            <s-button icon="" label="NON" 
                                :theme="!public ? 'is-danger is-small' : 'is-light is-small'"
                                @onclick="changePublicTournoi()"
                                :disabled="club.demo" />
                            </td>
                        </tr>
                        <tr v-if="club.public &&  typeof(tournoi.saison)=='undefined'">
                            <td colspan="2">
                            <div v-if="public">
                                En mettant votre tournoi public, vous permettez à n'importe quel utilisateur de s'inscrire à ce tournoi.<br/>
                            </div>
                            <div v-if="!public">
                                <s-l id="tournoiReserved"> Ce tournoi est réservé aux membres ou à des invités que vous avez décidé.</s-l>
                                
                                <div v-if="demo">
                                    <s-l id="tournoiReservedDemo">En mode démo, le tournoi ne peut être public.</s-l>
                                </div>
                                <div v-else>
                                   <s-l id="tournoiReservedNotDemo"> Vous pouvez le rendre public si vous cliquez sur OUI</s-l>
                                </div>
                            </div>
                            </td>
                        </tr>
                        <tr v-if="zones.length==0">
                            <td colspan="2">
                               <s-l id="notZonesInClub"> Les terrains de votre club n'ont pas été paramétrés. Si vous souhaitez attribuer des terrains aux équipes de votre tournoi, veuillez les paramétrer</s-l>
                            </td>
                        </tr>
                        <tr v-if="zones.length>0">
                            <td>
                                <s-l id="zoneChoiced">Les zones choisies pour affecter des terrains aux équipes sont :</s-l>
                                
                                <div v-if="!(typeof(tournoi.options.zones)=='undefined')" >
                                    <b v-for="zone in tournoi.options.zones">
                                        {{zone.name}}&nbsp;
                                    </b>
                                    <b v-if="Object.keys(tournoi.options.zones).length==0">
                                        Pas de terrains
                                    </b>
                                </div>
                                <b v-if="typeof(tournoi.options.zones)=='undefined'">
                                    Pas de terrains
                                </b>
                            </td>
                            <td style="text-align:center">
                                <s-button theme="is-primary is-small" label="Terrains" @onclick="openTerrains=true"/>
                            </td>
                        </tr>
                          </table>
                         
                    </div>
                    <s-modal
                        :open="openTerrains"
                        :close="true"
                        @close="openTerrains=false"
                    >
                       <s-l id="choiceZones"> Choisissez la ou les zones où les terrains seront affectés aux équipes :</s-l>
                       <div v-for="(zoneCurrent,key) in zones" class="ligneZone">
                            <s-button @onclick="addZoneInTournoi(zoneCurrent)" 
                                :icon="checkZone(zoneCurrent) ? 'check-circle' : 'circle'"
                                label=""
                                :theme="checkZone(zoneCurrent) ? 'is-success is-small' : 'is-dark is-small'"
                            />
                            {{zoneCurrent.name}} &nbsp;&nbsp; <i>({{zoneCurrent.nb==null ? '0' : (zoneCurrent.nb - zoneCurrent.nbNotDispo)}} terrains)</i>
                        </div>
                    </s-modal>
                    <s-modal    
                        :open="dateConfiguration"
                        title="Configuration de la demande de participation"
                        :cancel="true"
                        :save="true"
                        @cancel="dateConfiguration=false"
                        @save="saveDateLimiteEmail()"
                    >
                        <label>Les joueurs doivent s'incrire &nbsp;</label>
                        <input type="number" class="input is-primary is-small" style="width: 100px" v-model="delaiEmail"/> heures avant le début du tournoi
                        <div>
                            <s-l id="joueursInscrireEmail" :v="dateDelai.toLocaleString('fr-FR')">Les joueur doivent s'incrire avant le %v</s-l>
                        </div>
                        <hr/>
                         <div>
                            Les joueurs peuvent se désinscrire :
                             <s-button icon="" label="OUI" 
                                        :theme="unsubscribe ? 'is-success is-small' : 'is-light is-small'" 
                                        @onclick="setUnscribe()"
                                        :disabled="club.demo"
                                        />&nbsp;
                            <s-button icon="" label="NON" 
                                :theme="!unsubscribe ? 'is-danger is-small' : 'is-light is-small'"
                                @onclick="setUnscribe()"
                                :disabled="club.demo" />
                                <hr/>
                        </div>
                            <div v-if="unsubscribe">
                            <label>Les joueurs peuvent se désinscire avant &nbsp;</label>
                            <input type="number" class="input is-primary is-small" style="width: 100px" v-model="delaiEmailUnscribe"/> heures avant le début du tournoi
                            <div>
                                <s-l id="joueursInscrireEmail" :v="dateDelaiUnscribe.toLocaleString('fr-FR')">Les joueur doivent s'incrire avant le %v</s-l>
                            </div>
                        </div>
                    </s-modal>
                    
                    <s-modal 
                        id="sendMail"
                        :open="infoSendMailOK"
                        title="Mails envoyés"                        
                    >
                        <div>
                        Un mail vient d'être envoyer à aux membres qui ont un mail renseigné :
                            <div v-for="mail in sendMails">
                                {{mail}}
                            </div>
                        </div>
                        <div style="float:right;margin-top: 80px;">
                        <s-button @onclick="closeAndSendOrNotMail(false, true)" theme="is-success" label="J'ai compris"/>
                        </div>
                    </s-modal>
				</section>
				<footer class="modal-card-foot" v-show="createPossible || club.id=='demo'">
                    
                    <div style="width: 100%">

                        
                        <div class="buttonSave"  v-show="nav==0 && dupliquer" >
                            <s-button theme="is-success" label="Dupliquer" icon="save" 
                                @onclick="dupliquerAction()"
                                :disabled="tournoi.date==null"/>
                        </div>
                        <div class="buttonSave"  v-show="nav==0 && (tournoi.id=='' && !dupliquer)">
                            <s-button theme="is-success" label="Suivant" afterIcon="arrow-circle-right" 
                                @onclick="initTournoi"
                                :disabled="dateValue==null"/>
                        </div>
                        <div class="buttonSave"  v-show="nav==5 && (tournoi.id=='' && !dupliquer)">
                            <s-button theme="is-success" label="Suivant" afterIcon="arrow-circle-right" 
                                @onclick="nav--"
                                :disabled="dateValue==null"/>
                        </div>
                        <div class="buttonSave"  v-show="nav==0 && (tournoi.id!='' && !dupliquer && tournoi.start==null)">
                            <s-button theme="is-success" label="Modifier" afterIcon="arrow-circle-right" 
                                @onclick="initTournoi"
                                :disabled="tournoi.start!=null"/>
                        </div>
                        <div style="float:left"  v-show="nav>0 && nav<4">
                            <s-button theme="is-success" label="Précedent" icon="arrow-circle-left" 
                                @onclick="prec"
                                :disabled="tournoi.date==null"
                                />
                        </div>
                        <div style="float:left"  v-show="nav==4">
                            <s-button theme="is-warning" label="Annuler" icon="arrow-circle-left" 
                                @onclick="nav=0"
                                :disabled="tournoi.date==null"
                                />
                        </div>
                        <div v-show="nav==4 && tournoi.id!=''" 
                        style="float:right;text-align:right;width:50%">
                            <s-button 
                                :theme="classCreate" label="Enregistrer" icon=""
                                @onclick="create"
                                :disabled="disabledSave"
                                /><br/>
                        </div>
                        <div v-show="nav==4 && tournoi.id==''" 
                            style="float:right;text-align:right;width:50%">
                            <s-button 
                                :theme="classCreate" label="Créer le tournoi" icon=""
                                @onclick="create"
                                :disabled="disabledSave"/><br/>
                            <span v-if="clubIsSubscription">
                                concours illimité : le club est abonné
                            </span>
                            <span v-if="!clubIsSubscription && !clotured">
                                <b v-show="!demo && club.id!='demo'">Vous allez être débité d'1 credit </b>
                                <b v-show="demo && club.id!='demo'">Gratuit : vous êtes en mode tuto</b>
                                <b v-show="!demo && club.id=='demo'">Gratuit : vous êtes en mode essai</b>
                            </span>
                            
                        </div>
                    </div>
    			</footer>
               
  			</div>
    </div>
   
</template>
<style scoped>
    .demo {
        font-weight: bolder;
        color: black;
        font-size: 20px;
        text-align: center;
        width: 200px;
    }
    .errorDate {
        color: rgb(236, 69, 69);
        font-size: 14px;
        font-weight: bolder;
        font-style: italic;
    }
    .saison {
        margin: 20px;
        color: black;
        display: inline-block;
        width: 100%;
        font-size: 20px;
        font-weight: bolder;
    }
    .creditInsuffisant {
        font-weight: bolder;

    }
    .saisonSelect {
        padding: 10px;
        border: thin solid var(--bluebg);
        color: black;
        margin-top: 10px;
        cursor: pointer;
        font-weight: bolder;
    }
    .saisonSelect:hover {
        background-color: antiquewhite;
    }
    .ssection {
        height: 550px;
    }
    .labelBareme {
        width: 180px;
        font-weight: bold;
        display: inline-block;
    }
    .tableRecap {
        width: 100%
    }
    .tableRecap tr {
        border-bottom: thin black solid;
    }
    .tableRecap tr.notBottom {
        border-bottom: none;
    }
    .tableRecap td {
        padding: 3px;
        color: black;
         margin-bottom: 2px;
    }
    .tableRecap th {
        padding: 3px;
        
         margin-bottom: 2px;
    }
   
    .buttonSave {
        float: right;
    }
    
    .fil {
        width: 100%;
        height: 30px;
        font-weight: bold;
        color: #34495E;
        background-color: beige;
        padding: 5px;
    }
   
  
</style>
<script>
import club_fct from "@/firebase/club"
import tournoi_fct from "@/firebase/tournoi"
import firebase_api from "@/firebase/firebase_api"
import credit_fct from "@/firebase/credit"
import mail_fct from "@/firebase/mails"
import filterItem     from '@/views/joueurs/filterItem.vue'
import listSelect     from '@/views/tournoi/list/listSelectTunnel.vue'
import listSubscriptions from '@/views/payment/listSubscriptions.vue'
import creditsByVideo from '@/views/payment/creditsByVideo.vue'

export default {
    props: {
        club:{
            type: [Array, Object]
        },
        tournoi: {
            type: Object
        },
        open:{
            type: Boolean
        },
        saisons: {
            type: [Array]
        },
        saisonTournoi: {
            type: Object,
            default: null
        },
        dupliquer: {
            type: Boolean,
            default: false
        },
        clotured: {
             type: Boolean,
            default: false
        }
    },
    components: {
        filterItem,
        listSelect,
        listSubscriptions,
        creditsByVideo
        
    },
     data() {
        return {
            zones: [],
            openTerrains: false,
            sendMails: [],
            infoSendMailOK: false,
            sendMailFinish: false,
            sendCredit: false,
            demo: false,
            modifier: false,
            public: false,
            openAbonnement: false,
            errorDate: false,
            dateValue: null,
            dateConfiguration: false,
            
            unsubscribe: false,
            subscribe: false,
            delaiEmail: 0,
            delaiEmailUnscribe: 0,
            formations: 
                [
                    {
                        id: 0,
                        title: "Tête à tête",
                        description: "En tête à tête ou en individuel, les joueurs jouent seuls en 1 contre 1. Les joueurs jouent avec 3 boules",
                        classPlayer1: ['femmePlayer','vieuxPlayer','adoPlayer', 'player0','player1'],
                        classPlayer2: ['femmePlayer','vieuxPlayer','adoPlayer', 'player0','player1'],
                        classPlayer3: ['femmePlayer','vieuxPlayer','adoPlayer', 'player0','player1'],
                        change: 0,
                        value: 1

                    },
                    {
                        id: 1,
                        title: "En doublette",
                        description: "En doublette, les joueurs jouent avec un partenaire. Les joueurs jouent avec 3 boules",
                        classPlayer1: ['femmePlayer','vieuxPlayer','adoPlayer', 'player0','player1'],
                        classPlayer2: ['femmePlayer','vieuxPlayer','adoPlayer', 'player0','player1'],
                        classPlayer3: ['femmePlayer','vieuxPlayer','adoPlayer', 'player0','player1'],
                        change: 0,
                        value: 2
                    },
                    {
                        id: 2,
                        title: "En triplette",
                        classPlayer1: ['femmePlayer','vieuxPlayer','adoPlayer', 'player0','player1'],
                        classPlayer2: ['femmePlayer','vieuxPlayer','adoPlayer', 'player0','player1'],
                        classPlayer3: ['femmePlayer','vieuxPlayer','adoPlayer', 'player0','player1'],
                        description: "En triplette, les joueurs jouent avec 2 partenaires. Les joueurs jouent avec 2 boules",
                        change: 0,
                        value: 3
                    },
                    {
                        id: 3,
                        title: "Custom",
                        classPlayer1: ['onePlayer','playerForme','player3Forme'],
                        classPlayer2: ['femmePlayer','vieuxPlayer','adoPlayer', 'player0','player1'],
                        classPlayer3: ['femmePlayer','vieuxPlayer','adoPlayer', 'player0','player1'],
                        description: "Vous pouvez customiser votre concours. Vous choisissez différentes formations pour chaque partie",
                        change: 10,
                        value: -1
                    }
                ]
            ,
            compositions: 
                [
                    {
                        id: 0,
                        title: "Mélée",
                        description: "En mélée tournante, toutes les équipes sont tirées au sort à chaque partie, chaque joueur a donc un coéquipier différent à chaque partie. Ils rencontrent des adversaires différents à chaque partie",
                        classPlayer1: ['femmePlayer','vieuxPlayer','adoPlayer', 'player0','player1'],
                        classPlayer2: ['femmePlayer','vieuxPlayer','adoPlayer', 'player0','player1'],
                        classPlayer3: ['femmePlayer','vieuxPlayer','adoPlayer', 'player0','player1'],
                        change: 10,
                        value:"ALEA"
                    },
                    {
                        id: 1,
                        title: "Formée",
                        classPlayer1: ['femmePlayer','vieuxPlayer','adoPlayer', 'player0','player1'],
                        classPlayer2: ['femmePlayer','vieuxPlayer','adoPlayer', 'player0','player1'],
                        classPlayer3: ['femmePlayer','vieuxPlayer','adoPlayer', 'player0','player1'],
                        description: "Les équipes ne sont pas tirées au sort. Elles sont contituées en début de concours (lors de l'inscription. Ils joueront ensemble pendant toute la durée du concours",
                        change: 0,
                        value:"FORME"
                    },
                    {
                        id: 2,
                        title: "Formée aléatoire",
                        description: "Toutes les équipes sont tirées au sort à la première partie, ils sont coéquipiés pour chaque partie",
                        classPlayer1: ['femmePlayer','vieuxPlayer','adoPlayer', 'player0','player1'],
                        classPlayer2: ['femmePlayer','vieuxPlayer','adoPlayer', 'player0','player1'],
                        classPlayer3: ['femmePlayer','vieuxPlayer','adoPlayer', 'player0','player1'],
                        change: 30,
                        value:"MELEE"

                    }
                ]
            ,
            types: 
                [
                    {
                        id: 0,
                        title: "Aléatoire",
                        description: "Dans ce mode, les adversaires sont tirés au sort. Cependant un joueur ne peut pas rencontrer 2 fois la même personne pendant le concours",
                        classPlayer1: ['tournoiWithoutElim'],
                        classPlayer2: [],
                        classPlayer3: [],
                        change: 30,
                        value:1

                    },
                    {
                        id: 1,
                        title: "Gagnant Gagnant",
                        description: "En mode Gagnant Gagnant, les gagnants d'une partie se rencontrent dans la suivante et les perdants aussi. Les joueurs ne peuvent pas se recontrer 2 fois",
                        classPlayer1: ['tournoiGG'],
                        classPlayer2: [],
                        classPlayer3: [],
                        change: 10,
                        value:2
                    },
                    {
                        id: 2,
                        title: "Par poules",
                        classPlayer1: ['tournoiWithElim'],
                        classPlayer2: [],
                        classPlayer3: [], description: "Les équipes sont réparties et se rencontrent en petit groupe (3 ou 4 par poule). Les 2 premiers sont qualifiés dans des phases éliminiatoire (8ème, quart de final, demi-final, final). Il ne peut en rester qu'un !",
                        change: 0,
                        value:3,
                        mode : "FORME"
                    }
                ]
            ,
            
            nav:0,
            classModal: 'modal'    ,
            
            title: [
                "Configurer votre tournoi",
                "Choisir la formation",
                "Choisir la composition",
                "Déroulement du tournoi",
                "Récapitulatif"],
            optionsDate :{ 
                    weekday: 'short', 
                    year: 'numeric', 
                    month: 'short', 
                    day: 'numeric' },
            classCreate: "is-success",
            emailAll: false,
            openListSeason: false,
            saison: null
        }     
    },
    watch: {
            club: function(val) {
                if (val.id == 'demo' && this.nav==0) {
                    this.nav=1;
                    if (this.club.id=="demo") {
                        this.tournoi.date = (new Date()).getTime();
                        this.dateValue = this.$dateToYYYYMMDD(this.tournoi.date);
                        this.nav = 1;
                    }
                }

            },
            public: function(val) {
                this.tournoi.public = val;
            },
			open: function(val) {
               
                this.modifier = false;
                if (typeof(this.club.demo)!="undefined") {
                    this.tournoi.demo = this.club.demo;
                    this.demo = this.club.demo;
                    
                }
				if (val) {
                    this.classModal = "modal is-active";
                    if (this.tournoi.id != '') {
                       this.dateValue = this.$dateToYYYYMMDD(this.tournoi.date);
                       this.tournoi.public = this.public;
                    }
                }
				else {
                    this.classModal = "modal";
                }
                if (typeof(this.tournoi.saison)!="undefined")
                    this.saison = this.tournoi.saison;
                else
                    this.saison = null;
                
                if (typeof(this.club.delaiEmail)!="undefined") {
                    this.delaiEmail = this.club.delaiEmail;
                    if (this.tournoi.id != '') {
                        this.delaiEmail = this.tournoi.options.delaiEmail
                    }
                    this.tournoi.options.delaiEmail = this.delaiEmail;
                }
                if (typeof(this.club.delaiEmailUnscribe)!="undefined") {
                    this.delaiEmailUnscribe = this.club.delaiEmailUnscribe;
                    if (this.tournoi.id != '') {
                        this.delaiEmailUnscribe = this.tournoi.options.delaiEmailUnscribe
                    }
                    this.tournoi.options.delaiEmailUnscribe = this.delaiEmailUnscribe;
                }
                if (typeof(this.club.unsubscribe)!="undefined") {
                    this.unsubscribe = this.club.unsubscribe;
                    if (this.tournoi.id != '') {
                        this.unsubscribe = this.tournoi.options.unsubscribe;
                    }
                    this.tournoi.options.unsubscribe = this.unsubscribe;
                }
                if (typeof(this.club.subscribe)!="undefined") {
                    this.subscribe = this.club.subscribe;
                    if (this.tournoi.id != '') {
                        this.subscribe = this.tournoi.options.subscribe;
                    }
                    this.tournoi.options.subscribe = this.subscribe;
                }
                if (typeof(this.club.emailAll)!="undefined") {
                    this.emailAll = this.club.emailAll;
                    if (this.tournoi.id != '') {
                         this.emailAll = this.tournoi.options.emailAll;
                    }
                    this.tournoi.options.emailAll = this.emailAll;
                }
                else
                    this.emailAll = false;
                this.refreshTerrains();
            },
            nav: function(newVal, oldVal) {
                if (this.tournoi.options.nbJoueursParEquipe == 1 && newVal<3) {
                    this.tournoi.options.mode = "ALEA";
                    if (newVal==2) {
                        if (newVal>oldVal)
                            this.nav=3;
                        else
                            this.nav=1;
                    }
                }
                if (newVal==0 && this.club.id=="demo") {
                    this.nav = 1;
                }
                switch (newVal) {
                    case 1:
                        
                        if (this.saisonTournoi==null) {
                            this.tournoi.options.nbJoueursParEquipe=null;
                        }
                        else {
                            this.tournoi.options = JSON.parse(JSON.stringify(this.saisonTournoi.options));
                            this.nav=4;
                           
                        }
                        break;
                    case 2:
                        
                        this.tournoi.options.mode=null;
                        this.tournoi.options.GG=false;
                        break;
                    case 3:
                        if (this.saisonTournoi==null) {
                            this.tournoi.options.competition=null;
                            this.tournoi.options.GG=false;
                        }
                        else {
                            this.nav=0;
                        }
                         break;
                    case 4:
                        break;
                }
            }
		},
    computed: {
        
        disabledSave: {
            get() {
                return (this.tournoi.options.competition==null 
                        || this.tournoi.options.mode==null
                        || this.tournoi.options.nbJoueursParEquipe==null)
            }
        },
        dateDelai: {
            get() {
                var dateCalc = this.dateToGetTime(this.dateValue)
                return this.$dateLimit(dateCalc, this.tournoi.heure, this.delaiEmail);
            }
        },
        dateDelaiUnscribe: {
            get() {
                var dateCalc = this.dateToGetTime(this.dateValue)
                return this.$dateLimit(dateCalc, this.tournoi.heure, this.delaiEmailUnscribe);
            }
        },
        saisonLibelle: {
            get() {
                var saison = null;
                if (typeof(this.saisons)!="undefined") {
                    if (typeof(this.saison)!="undefined") {
                        
                        if (this.saison != null) {
                            
                            var findSaison = this.saisons.findIndex(elt=>elt.id === this.saison);
                            
                            if (findSaison!=-1)
                                saison = this.saisons[findSaison].nom;
                        }                    
                    }
                }
                return saison;
            }
            
        },
        getToday: {
            get() {
                if (!this.clotured) {
                    var date = new Date();
                    return this.date2str(date,  'yyyy-MM-dd');
                }
            }
        },
        getDayMax: {
            get() {
                if (this.clotured) {
                    var date = new Date();
                    return this.date2str(date,  'yyyy-MM-dd');
                }
                else {
                    return "3000-01-01"
                }
            }
        },
        yearToDay: {
            get() {
                var date = new Date();
                return date.getFullYear();
            }
        },
        clubIsSubscription: {
            get() {
                if (typeof(this.club.subscription) != "undefined")
                    if (this.club.subscription.status == "active") {
                        var date = new Date();
                        var endDate = this.club.subscription.period_end.toDate();
                        var startDate =  this.club.subscription.period_start.toDate();
                        endDate.setDate(endDate.getDate() + 7);
                        if (startDate < date && date < endDate)
                            return true;
                        else
                            return false;
                    }
                    else
                        return false;
                else
                    false;
            }
        },
        isCreditOrSubscription: {
            get() {
                var subscription = this.clubIsSubscription;
                if (subscription)
                    return true;
                else 
                    return this.credit>0
            }
        },
        createPossible: {
            get() {
                if (this.clotured)
                    return true;
                else if (this.tournoi.id != '' && !this.dupliquer)
                    return true;
                else
                    return this.demo || this.isCreditOrSubscription;
            }
        },
        credit: {
            get() {
            
                    if (this.$store.getters.getCredit == null)
                        return 0;
                    else
                        return this.$store.getters.getCredit.credit
            }
        },
       
        
        dateTournoi: {
            get() {
                return this.formatDate(this.tournoi.date);
            }
        },
        
    },
    mounted() {
     
        
        if (typeof(this.club.demo)!="undefined") {
           
            this.tournoi.demo = this.club.demo;
            this.demo = this.club.demo;
            
        }
        this.dateValue = this.getToday;
        
      
            
        /*if (this.tournoi.id != null) {
            this.tournoi.date = this.$dateToYYYYMMDD(this.tournoi.date);
        }*/
    },
   
    methods: {
        checkZone(zone) {
            
            if (typeof(this.tournoi.options.zones)=="undefined")
                return false;
            else {
                return typeof(this.tournoi.options.zones[zone.name])!="undefined";
            }
        },
        addZoneInTournoi(zone) {
            if (typeof(this.tournoi.options.zones)=="undefined")
                this.tournoi.options.zones = {};
          
            if (!this.checkZone(zone))
                this.tournoi.options.zones[zone.name]=zone;
            else 
                delete this.tournoi.options.zones[zone.name];
            this.openTerrains = false;
            this.openTerrains = true;
        },
        refreshTerrains() {
            this.zones=[];
            firebase_api.api.getDb().collection("club").doc(this.club.id)
                    .collection("terrains").get().then(docs=>{
                        docs.forEach((doc, indiceDoc)=>{
                            var zone = doc.data();
                            if (zone.default) {
                                if (typeof(this.tournoi.options.zones)=="undefined")
                                    this.tournoi.options.zones = {};
                                this.tournoi.options.zones[zone.name] = zone;
                            }
                            this.zones.push(zone);
                        })
                    })
        },
        setEmailALL() {
            this.emailAll = !this.emailAll;
            firebase_api.api.getDb().collection("club").doc(this.club.id).update({
                emailAll : this.emailAll
            });
            this.tournoi.options.emailAll = this.emailAll;
        },
        setUnscribe() {
            this.unsubscribe = !this.unsubscribe;
            firebase_api.api.getDb().collection("club").doc(this.club.id).update({
                unsubscribe : this.unsubscribe
            });
            this.tournoi.options.unsubscribe = this.unsubscribe;
        },
        setSubscribe() {
            this.subscribe = !this.subscribe;
            firebase_api.api.getDb().collection("club").doc(this.club.id).update({
                subscribe : this.subscribe
            });
            this.tournoi.options.subscribe = this.subscribe;
        },
        openDateConfiguration() {
            this.dateConfiguration  = true;
            if (typeof(this.club.delaiEmail)!="undefined") {
                this.delaiEmail = parseInt(this.club.delaiEmail);
            }
            if (typeof(this.club.delaiEmailUnscribe)!="undefined") {
                this.delaiEmailUnscribe = parseInt(this.club.delaiEmailUnscribe);
                this.unsubscribe = this.club.unsubscribe; 
            }
        },
        saveDateLimiteEmail() {
            
            this.tournoi.options.delaiEmail = parseInt(this.delaiEmail);
            this.tournoi.options.delaiEmailUnscribe = parseInt(this.delaiEmailUnscribe);
            firebase_api.api.getDb().collection("club").doc(this.club.id).update({
                delaiEmail: parseInt(this.delaiEmail),
                delaiEmailUnscribe: parseInt(this.delaiEmailUnscribe)
            })
            this.dateConfiguration = false;
           
        },
        changePublicTournoi() {
            this.public =  !this.public ;
        },
        date2str(x, y) {
            var z = {
                M: x.getMonth() + 1,
                d: x.getDate(),
                h: x.getHours(),
                m: x.getMinutes(),
                s: x.getSeconds()
            };
            y = y.replace(/(M+|d+|h+|m+|s+)/g, function(v) {
                return ((v.length > 1 ? "0" : "") + z[v.slice(-1)]).slice(-2)
            });

            return y.replace(/(y+)/g, function(v) {
                return x.getFullYear().toString().slice(-v.length)
            });
        },
        //*********************** METHODS FOR STEP0 */
        dateToGetTime(date) {
            var dateData = new Date(date);
           // var workDate = new Date(dateData.getFullYear(), dateData.getMonth(), dateData.getDate());
           
            return dateData.getTime();
            
        },
        changeDate() {
            var dateData = new Date(this.tournoi.date);
            var workDate = new Date(dateData.getFullYear(), dateData.getMonth(), dateData.getDate());
           
            this.tournoi.date = workDate.getTime();
            
            this.errorDate = false;
            
        },
        async initTournoi() {
            this.modifier = true;
            this.verifyDateTournoiValid(verifyDate=>{
                if (verifyDate) {
                    this.nav++;
                    this.errorDate = false;
                    this.tournoi.date = this.dateToGetTime(this.dateValue);
                }
                else {
                    this.errorDate = true;
                }
            });
        },
        inclureSaison(saisonId) {
            this.saison = saisonId;
            this.openListSeason = false;
        },
        detacherSaison() {
            
            this.saison = null;
           
        },
        //********************** METHODS FOR STEP 1 ********************* */
        //********************** FORMATION ********************* */
        setNbJoueursParEquipeByPartie(partie, nbJoueur) {
            this.tournoi.options.nbParties++;
            this.tournoi.options.nbParties--;
            this.tournoi.options.tabNbJoueursParEquipe[parseInt(partie)-1] = nbJoueur;
            
        },
        setNbJoueursParEquipe(nbJoueur) {
            
            this.tournoi.options.nbJoueursParEquipe = nbJoueur;
            if (nbJoueur==-1) {
                this.tournoi.options.tabNbJoueursParEquipe=[1,2,3];
                this.tournoi.options.mode = "ALEA";
                this.tournoi.options.melee = true;
                this.tournoi.options.competition = 1
                this.nav = 5;
            }
            else
                this.nav++;
        },
        //********************** METHODS FOR STEP 2 ********************* */
        //********************** FORMATION ********************* */
         setMode(mode) {
             
            if (mode=='MELEE') {
                this.tournoi.options.mode = "FORME";
                this.tournoi.options.melee = true;
            }
            else {
                this.tournoi.options.mode = mode;
                this.tournoi.options.melee = false;
            }
            this.nav++;
        },
        
        //********************** METHODS FOR STEP 3 ********************* */
        //********************** DEROULEMENT ********************* */

        setCompetition(compet) {
            
            this.tournoi.options.competition = compet;
            if (compet == 1) {
                this.tournoi.options.GG = false;
                var tournoiJson = JSON.parse(JSON.stringify(tournoi_fct.object.data));
                this.tournoi.options.nbParties = tournoiJson.options.nbParties;
                 if (this.tournoi.options.nbJoueursParEquipe==1) {
                     this.tournoi.options.mode = "ALEA";
                     this.tournoi.options.melee = true;
                 }
            }
            else if (compet == 2) {
                this.tournoi.options.GG = true;
                this.tournoi.options.nbParties = 1;
                 if (this.tournoi.options.nbJoueursParEquipe==1) {
                      this.tournoi.options.mode = "ALEA";
                      this.tournoi.options.melee = true;
                 }
            }
             else if (compet == 3) {
                  this.tournoi.options.GG = false;
                  if (this.tournoi.options.nbJoueursParEquipe==1) {
                   
                    // comme le nombre de joueurs est individuel alors on force pout mettre en forme
                    this.tournoi.options.mode = "FORME";
                    this.tournoi.options.melee = true;
                    
                  }
            }
            this.nav++;
        },
          //********************** METHODS FOR STEP 4 ********************* */
        //********************** CREATE ********************* */
        async dupliquerAction() {
            this.tournoi.id = '';
            this.initTournoi();
            await this.create();
        },
       
        sendMailAll() {
            
            var demo = typeof(this.club.demo) == "undefined" ? false : this.club.demo;
            this.sendMailFinish = false;
            if (this.emailAll && !demo) {
                this.sendMails = [];
             
                firebase_api.api.getDb().collection("club").doc(this.club.id)
                    .collection("joueurs").where("email", "!=", "").get().then(joueurs=>{
                        joueurs.docs.forEach((joueurDoc, indiceJoueurDoc)=>{
                            var joueurData = joueurDoc.data();
                            var params= {
                                club: this.club.name,
                                idClub: this.club.id,
                                url: window.location.origin + '/participeTournoi',
                                tournoiDate: this.dateTournoi + ' à ' + this.tournoi.heure,
                                email: joueurData.email,
                                dateLimit: this.dateDelai.toLocaleString('fr-FR'),
                                idTournoi: this.tournoi.id
                            }
                            this.sendMails.push(joueurData.nom + ' '+joueurData.prenom);
                            var idMail = "TOURNOI_CREER";
                            if (!this.subscribe)
                                idMail = "TOURNOI_CREER_SANS_LIEN";
                            mail_fct.object.sendEmail(joueurData.email, idMail, params);
                            
                            if (indiceJoueurDoc==joueurs.docs.length-1) {
                                  this.infoSendMailOK = true;  
                                  this.sendMailFinish = true;
                            }
                                
                        })
                })
            }
        },
        async create() {
            
              // voir comment on récupère pour le deleguate
            
            this.classCreate = "is-success is-loading";
            
            this.tournoi.state="INSCRIPTION";
            var authID = this.$store.getters.getUser.authId;
            if (this.saison!=null) {
                this.tournoi.saison = this.saison;
                
            }
            
            if (this.clubIsSubscription || this.demo || this.club.id=='demo' || (this.tournoi.id != '' && this.tournoi.start==null)) {
                this.save(false);
            }
            else if (this.tournoi.id=='') {
                if (!this.clotured) {
                    credit_fct.object.add(null , -1, authID, async ()=>{
                        this.save(false);
                    })
                }
                else
                    this.save(false);
            }
           
                
           
        },
        async save(close) {
                
                this.tournoi.clotured = this.clotured;
                if (this.clotured)
                    this.tournoi.state = "FINISH";
                if (typeof(close)=="undefined")
                    close = true;
                if (this.saison!=null) {
                    this.tournoi.saison = this.saison;
                }
                
                if (this.club.id=='demo') {
                    this.tournoi.owner = this.$store.getters.getUser.email;
                    if (this.tournoi.owner != "anonyme@petanque-app.com") {
                        var tournoisDemoDoc = firebase_api.api.getDb().collection("club").doc(this.club.id).collection("tournois")
                            .where("owner","==",this.tournoi.owner);
                        var tournoisDemoRef  = await tournoisDemoDoc.get();
                        for (var keyDoc in tournoisDemoRef.docs) {
                             tournoisDemoRef.docs[keyDoc].ref.delete();
                        }
                    }
                }
                this.verifyDateTournoiValid(async verifyDate=>{
                    if (verifyDate) {
                        this.errorDate = false;
                        this.classCreate = "is-success is-loading"
                        var newTournoi = this.tournoi.id == '';
                        await tournoi_fct.object.set(this.club, this.tournoi, async tournoi=> {
                            this.closeAndSendOrNotMail(close, newTournoi);
                        })
                    }
                    else {
                        this.errorDate = true;
                    }
                });
                
        },
        async closeAndSendOrNotMail(close, newTournoi) {
            var demo = typeof(this.club.demo) == "undefined" ? false : this.club.demo;
            
            if ((!this.emailAll || demo) || this.sendMailFinish || !newTournoi) {
                this.infoSendMailOK = false;  
                this.sendMailFinish = false;
                if (close)
                    this.close();
                else {
                    this.$emit("saved", this.tournoi);
                    await tournoi_fct.object.addJoueursBySeason(this.club, this.tournoi);
                }
                this.nav=0;
                this.classCreate = "is-success";
            }
            else if (newTournoi)
                this.sendMailAll();
        },
         //********************** METHODS GENERIC ********************* */
        formatDate(date) {
            var options = { year: "2-digit", month: "2-digit", day: "2-digit"};
            return (new Date(date)).toLocaleString("fr-Fr",options);
        },
        prec() {
            if (this.nav==1 && this.club.id=="demo") {
                if (this.$store.getters.getUser.email=='anonyme@petanque-app.com')
                        this.$router.push({name: "home"})
                else
                    this.$router.push({name: "club"}).catch(error=>{});
            }
            else if (this.tournoi.options.nbJoueursParEquipe==-1)
                this.nav=1;
            else
                this.nav--;
        },
        close() {
            this.nav=0;
            this.demo=false;
            this.$emit("close")
        },
        payment() {
              this.$router.push({name: "payment"}).catch(error=>{});
        },
        verifyDateTournoiValid(fct) {
            var bool = true;
            if (this.demo || this.clotured)
                fct(true);
            else {
                var date = this.dateToGetTime(this.dateValue);
                tournoi_fct.object.verifyDate(this.club, date, this.tournoi.id, bool=>{
                    fct( bool)
                });
            }
        }
        
    }
}
</script>